// Importaciones de React, Framer Motion, y los componentes y hooks necesarios.
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Modal from './Modal'; // Importamos el componente Modal.
import drop from '../img/drop.jpg';
import dropp from '../img/dropp.jpg';
import droppp from '../img/droppp.jpg';

/**
 * Componente Empresa.
 * Muestra información sobre la empresa en tres secciones.
 * Al hacer clic en "Ver más", se abre un modal con la información detallada.
 */
export const Empresa = () => {
  // Estado para controlar la visibilidad del modal.
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Estado para almacenar el contenido que se mostrará en el modal.
  const [modalContent, setModalContent] = useState({ title: '', description: '' });

  // Array de objetos con la información de cada sección.
  const empresaInfo = [
    {
      id: 1,
      image: drop,
      title: 'Quiénes Somos',
      content: 'DS CYBER, es fundada con el propósito de apoyar a nuestros clientes en aumentar la productividad y reducir los riesgos de ciberseguridad. Inteligencia artificial, ciberseguridad y la consultoria tecnológica, cubiertos bajo el  enfoque de  la automatización es la ruta que ofrecemos para el éxito de nuestros clientes.'
    },
    {
      id: 2,
      image: dropp,
      title: 'Nuestro equipo',
      content: 'Nuestro equipo es el pilar fundamental para el logro de nuestros objetivos, contamos con mas de 20 años de experiencia en diferentes sectores de la economía: salud, educación, automotriz, finanzas, entre otros, que nos dan una visión amplia de como atender su requerimiento​.'
    },
    {
      id: 3,
      image: droppp,
      title: 'Nuestra Razon de Ser',
      sections: [
        {
          title: 'Misión',
          text: 'Proveer a nuestros clientes de un servicio integral que apoye su protección cibernética y la automatización de tareas.'
        },
        {
          title: 'Visión',
          text: 'Ser líder en el mercado de ciberseguridad e inteligencia artificial.'
        }
      ],
      values: [
        {
          title: 'Compromiso',
          text: 'Se basa en la determinación para brindar el mejor servicio a nuestros clientes internos y externos a través de la responsabilidad y respeto.'
        },
        {
          title: 'Calidad',
          text: 'Este principio permite no solo cumplan con los requisitos técnicos y normativos, sino que también se ejecuten con altos estándares de desempeño, mejora continua y satisfacción del cliente.'
        },
        {
          title: 'Confianza',
          text: 'Fomentamos un entorno de confianza mutua entre colaboradores, clientes y socios, como base para garantizar la transparencia en nuestras operaciones.'
        }
      ]
    },
  ];

  // Función para abrir el modal y establecer su contenido.
  const openModal = (item) => {
    // If there's no simple content string but there are sections/values,
    // build a formatted description so the modal's parser preserves the layout
    let description = item.content || '';
    if (!description && (item.sections || item.values)) {
      const parts = [];
      if (item.sections) {
        item.sections.forEach(sec => {
          parts.push(`*${sec.title}`);
          if (sec.text) parts.push(sec.text);
        });
      }
      if (item.values) {
        parts.push('*Valores');
        item.values.forEach(v => {
          parts.push(`-${v.title}: ${v.text}`);
        });
      }
      description = parts.join('\n');
    }

    setModalContent({
      title: item.title,
      description,
      image: item.image,
      values: item.values || null,
      sections: item.sections || null,
      services: item.services || null,
      link: item.link || null
    });
    setIsModalOpen(true);
  };

  // Función para cerrar el modal.
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Variantes de animación para Framer Motion.
  const itemVariants = {
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, y: 20 },
  };

  return (
    <div className="w-full text-center py-10 p-10 ">
      <h2 className="text-4xl font-bold mb-10">LA EMPRESA</h2>
      <div className='linea'></div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {empresaInfo.map((item, index) => (
          <motion.div 
            key={index} 
            className="flex flex-col items-center mb-8" 
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="w-64 h-64 overflow-hidden rounded-lg shadow-lg" style={{ boxShadow: '0 0 10px 6px rgba(0, 0, 0, 0.3)' }}>
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
            </div>
            
            {/* Botón con el estilo del DropDownButton anterior, pero que abre un modal */}
            <div className="my-4 w-60 text-center mx-auto">
              <button
                onClick={() => openModal(item)}
                className="text-lg font-semibold rounded-full outline outline-offset-2 outline-blue-500 bg-white text-blue-500 p-2 w-full flex justify-center items-center cursor-pointer"
              >
                {item.title}
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Componente Modal que se renderizará aquí. */}
      <Modal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        content={modalContent} 
      />
    </div>
  );
};

export default Empresa;